// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import poApi from '~/apis/po';
import {
  CREATE_PO,
  DELETE_PO,
  EDIT_PO,
  GET_PO_LIST,
  GET_PO_NUMBER,
  GET_VENDOR_LIST,
} from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';
import { IFormPO, IPayloadEditPO, IRequestPOList } from '~/utils/interface/po';

export const getPOList = createAsyncThunk(
  GET_PO_LIST,
  async (request: IRequestPOList, { rejectWithValue }) => {
    try {
      const resp = await poApi.getPOList(request);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deletePO = createAsyncThunk(DELETE_PO, async (poId: string, { rejectWithValue }) => {
  try {
    const resp = await poApi.deletePO(poId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getVendorList = createAsyncThunk(
  GET_VENDOR_LIST,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await poApi.getVendorsList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getPONumber = createAsyncThunk(GET_PO_NUMBER, async (timeZone: string, { rejectWithValue }) => {
  try {
    const resp = await poApi.getPONumber(timeZone);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createPO = createAsyncThunk(CREATE_PO, async (body: IFormPO, { rejectWithValue }) => {
  try {
    const resp = await poApi.createPO(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const editPO = createAsyncThunk(EDIT_PO, async (payload: IPayloadEditPO, { rejectWithValue }) => {
  try {
    const resp = await poApi.editPO(payload);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
